const easeInOutQuad = (time, b, c, d) => {
  let t = time
  t = t / (d / 2)
  if (t < 1) {
    return c / 2 * t * t + b
  }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

export default function scrollTo ({ to, duration = 300 }) {
  const start = window.pageYOffset

  document.body.style.pointerEvents = 'none'
  document.body.style.willChange = 'scroll-position'

  setTimeout(() => {
    document.body.style.pointerEvents = 'auto'
    document.body.style.willChange = 'auto'
  }, duration + 100)

  const change = to - start
  const increment = 20
  let currentTime = 0

  const animateScroll = () => {
    currentTime += increment

    const val = easeInOutQuad(currentTime, start, change, duration)

    window.scrollTo(0, val)

    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }

  animateScroll()
}



// WEBPACK FOOTER //
// ./src/helpers/scroll-to.js